// src/utils/dateUtils.js

/**
 * Formats a Date object to DD-MM-YYYY string
 * @param {Date} date - Date to format
 * @returns {string} Formatted date string (e.g., "15-01-2024")
 */
export const formatDate = (date) => {
  const d = new Date(date);
  return `${d.getDate().toString().padStart(2, '0')}-${(d.getMonth() + 1).toString().padStart(2, '0')}-${d.getFullYear()}`;
};

/**
 * Checks if a date string represents today
 * @param {string} dateStr - Date string in DD-MM-YYYY format
 * @returns {boolean}
 */
export const isToday = (dateStr) => formatDate(new Date()) === dateStr;

/**
 * Checks if a date string represents a past date
 * @param {string} dateStr - Date string in DD-MM-YYYY format
 * @returns {boolean}
 */
export const isPast = (dateStr) => {
  const date = new Date(dateStr.split('-').reverse().join('-'));
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return date < today;
};

export const MONTHS_FI = ['Tammikuu', 'Helmikuu', 'Maaliskuu', 'Huhtikuu', 'Toukokuu', 'Kesäkuu',
  'Heinäkuu', 'Elokuu', 'Syyskuu', 'Lokakuu', 'Marraskuu', 'Joulukuu'];

/** Parses a DD-MM-YYYY id to a local Date */
export const parseId = (id) => {
  const [d, m, y] = id.split('-').map(Number);
  return new Date(y, m - 1, d);
};

/** DD-MM-YYYY id of the day after the given id */
export const nextDay = (id) => {
  const date = parseId(id);
  date.setDate(date.getDate() + 1);
  return formatDate(date);
};
